import { ReactFlow, Controls, Background } from "@xyflow/react";
import { useEffect, useState } from "react";
import "@xyflow/react/dist/style.css";
import CustomNode from "./CustomNode";
import { Badge ,Button} from "flowbite-react";
import { Users, Building2 ,ChevronDown,ChevronUp} from "lucide-react";
import axios from "axios";
export default function FlowChartAdminV() {
  const [open,setOpen] = useState(false)
  const [entityGraph, setentityGraph] = useState(null);
  const [franchisesList, setlistFranchises] = useState(null);
const fetchData = async()=> {
  try {
  const entityGraphInfoResponse = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}getentitygraph`,
          { withCredentials: true }
        );
        setentityGraph(entityGraphInfoResponse.data);
         const franchisesListResponse = await axios.get(
          `${
            process.env.REACT_APP_BACKEND_URL
          }getFranchisesByAdminV/?page=${1}&limit=${100}&search=${""}`,
          { withCredentials: true }
        );
        setlistFranchises(franchisesListResponse.data.franchises);
  }
  catch(error) {
    console.log(error)
  }
 
}

  const toggleDropdown = () => {
    if(!open) {
      fetchData()
    }
    setOpen(!open)
  }
  const nodeTypes = {
    custom: CustomNode,
  };

  const [nodes, setNodes] = useState([]);
  const [edges, setEdges] = useState([]);

  useEffect(() => {
    if (entityGraph) {
      const { nodes, edges } = generateFlowData(entityGraph, franchisesList);
      setNodes(nodes);
      setEdges(edges);
    }
  }, [entityGraph, franchisesList]);

  const generateFlowData = (graph, franchisesList) => {
    const nodes = [];
    const edges = [];

    const nodeColors = {
      AdminVente: "#ffffff",
      Commercial: "#d4edda",
      Distributor: "#e0cfe7",
      Franchise: "#cfe7f2",
      Pdv: "#f8f9fa",
    };

    const edgeColors = {
      fromadminV: "#D3D3D3",
      fromcommercial: "#28a745",
      fromdistributor: "#A020F0",
      fromfranchise: "#ADD8E6",
    };

    const xPositions = {
      AdminVente: 50,
      Commercial: 400,
      Distributor: 700,
      Franchise: 1000,
      Pdv: 1300,
    };

    const ySpacing = 200;

    const levelNodeCounts = {
      AdminVente: 0,
      Commercial: 0,
      Distributor: 0,
      Franchise: 0,
      Pdv: 0,
    };

    // Build a map of franchise user._id -> franchise
    const franchiseMap = new Map();
    if (franchisesList && Array.isArray(franchisesList.data)) {
      franchisesList.data.forEach((franchise) => {
        if (franchise.user && franchise.user._id) {
          franchiseMap.set(franchise.user._id.toString(), franchise);
        }
      });
    }

    graph.nodes.forEach((node) => {
      const level = node.type;
      const xPos = xPositions[level];
      const yPos = levelNodeCounts[level] * ySpacing;
      let fullData = node.data || {};

      // Hydrate Franchise nodes from map
      if (node.type === "Franchise" && franchiseMap.has(node.id)) {
        const franchise = franchiseMap.get(node.id);
        const nameParts = franchise.owner
          ? franchise.owner.split(" ")
          : ["", ""];

        fullData = {
          ...fullData,
          FirstName: nameParts[0] || "",
          LastName: nameParts.slice(1).join(" ") || "",
          StockTotal: franchise.stockTotal || 0,
          owner: franchise.owner || "",
        };
      }

      nodes.push({
        id: node.id.toString(),
        type: "custom",
        data: {
          Name:
            fullData.owner ||
            `${fullData.FirstName || ""} ${
              fullData.LastName || fullData.Name || ""
            }`.trim(),
          StockTotal: fullData.StockTotal || 0,
          role: node.type.toLowerCase(),
          id: node.id,
        },
        position: { x: xPos, y: yPos },
        style: {
          backgroundColor: nodeColors[node.type],
          padding: "10px",
          borderRadius: "8px",
          border: "1px solid #ccc",
        },
      });

      levelNodeCounts[level]++;
    });

    graph.edges.forEach((edge) => {
      edges.push({
        id: `${edge.from}-${edge.to}`,
        source: edge.from.toString(),
        target: edge.to.toString(),
        type: "default",
        style: {
          stroke: edgeColors[edge.relationship] || "#E5E4E2",
          strokeWidth: 2,
        },
      });
    });

    return { nodes, edges };
  };

  return (
    <div className="p-4 bg-white border border-gray-200 rounded-lg shadow-sm dark:border-gray-700 sm:p-6 dark:bg-gray-800 flex flex-col gap-4">
      <div className="flex justify-between">
       <div >
          <h3 className="text-xl font-bold text-gray-900 dark:text-white">
            Vos utilisateurs
          </h3>
          <span className="text-base font-normal text-gray-500 dark:text-gray-400">
            Organigramme relationnel des utilisateurs
          </span>
        </div>
        <div ><Button pill size="xs" color={"dark"} onClick={toggleDropdown}>{open ? <ChevronUp size={16}/> : <ChevronDown size={16}/>}</Button></div>
        </div>
      {open && <>
       <div className="items-center mb-4 justify-between lg:flex">
       
        <div className="flex flex-row gap-1">
          <Badge className="p-2" icon={() => <Users size={16} />}>
            Commericaux : {entityGraph?.commercialsCount}
          </Badge>
          <Badge
            className="p-2"
            color="warning"
            icon={() => <Building2 size={16} />}
          >
            Franchises : {entityGraph?.franchisesCount}
          </Badge>
        </div>
      </div>
      <div style={{ height: "500px" }}>
        <ReactFlow
          nodes={nodes}
          edges={edges}
          nodeTypes={nodeTypes}
          defaultViewport={{
            x: 0,
            y: 0,
            zoom: 0.2, // You can adjust this value (0.5 = 50% zoom)
          }}
        //   fitView // This will automatically fit all nodes in the viewport
          
        >
          <Background />
          <Controls />
        </ReactFlow>
      </div>
        </>}
     
    </div>
  );
}
